import { render, staticRenderFns } from "./appLogout.vue?vue&type=template&id=06049361&"
import script from "./appLogout.vue?vue&type=script&lang=js&"
export * from "./appLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports